<div [class.compact-view]="compactView" [class.compact-view-extended]="compactView && showAllFilterInCompactView" class="filter-group">
  <div class="filter-group-area">
    @for (filter of filterOptionsVisible; track trackByFn($index, filter)) {
      @switch (filter.type) {
        @case ('select') {
          <nimbus-nimbus-filter-select
            [filterValue]="filterGroupValue[filter.id]"
            [disabled]="disabled"
            [filter]="filter"
            [openOnInit]="isFilterOpenedOnInit(filter.id)"
            (filterValueChanged)="onFilterValueChanged(filter.id, $event)"
            (searchControlValueChanged)="onSelectSearchControlValueChanged(filter.id, $event)"
          ></nimbus-nimbus-filter-select>
        }
        @case ('duration') {
          <nimbus-filter-duration-range
            [filterValue]="filterGroupValue[filter.id]"
            [disabled]="disabled"
            [filter]="filter"
            [openOnInit]="isFilterOpenedOnInit(filter.id)"
            (filterValueChanged)="onFilterValueChanged(filter.id, $event)"
          ></nimbus-filter-duration-range>
        }
        @case ('dateRange') {
          <nimbus-filter-datetime-range
            [filterValue]="filterGroupValue[filter.id]"
            [disabled]="disabled"
            [filter]="filter"
            [openOnInit]="isFilterOpenedOnInit(filter.id)"
            [locale]="selectedDateFormat$ | async"
            (filterValueChanged)="onFilterValueChanged(filter.id, $event)"
          ></nimbus-filter-datetime-range>
        }
        @case ('search') {
          <nimbus-filter-search
            [filterValue]="filterGroupValue[filter.id]"
            [disabled]="disabled"
            [filter]="filter"
            [openOnInit]="isFilterOpenedOnInit(filter.id)"
            (filterValueChanged)="onFilterValueChanged(filter.id, $event)"
          ></nimbus-filter-search>
        }
        @case ('hierarchySelect') {
          <nimbus-filter-hierarchy-select
            [filterValue]="filterGroupValue[filter.id]"
            [disabled]="disabled"
            [filter]="filter"
            [openOnInit]="isFilterOpenedOnInit(filter.id)"
            (filterValueChanged)="onFilterValueChanged(filter.id, $event)"
          ></nimbus-filter-hierarchy-select>
        }
        @case ('text') {
          <nimbus-filter-text
            [filterValue]="filterGroupValue[filter.id]"
            [disabled]="disabled"
            [filter]="filter"
            [openOnInit]="isFilterOpenedOnInit(filter.id)"
            (filterValueChanged)="onFilterValueChanged(filter.id, $event)"
          ></nimbus-filter-text>
        }
        @case ('numberRange') {
          <nimbus-filter-number-range
            [filterValue]="filterGroupValue[filter.id]"
            [disabled]="disabled"
            [filter]="filter"
            [openOnInit]="isFilterOpenedOnInit(filter.id)"
            (filterValueChanged)="onFilterValueChanged(filter.id, $event)"
          ></nimbus-filter-number-range>
        }
      }
    }
    @if (compactView && filterOptionsSelected.length > DEFAULT_COMPACT_FILTERS_COUNT && !showAllFilterInCompactView) {
      <button (click)="toggleFilters()" class="filter-summary-button expander">...</button>
    }
  </div>
  @if (compactView && filterOptionsSelected.length > DEFAULT_COMPACT_FILTERS_COUNT && showAllFilterInCompactView) {
    <div class="close-icon">
      <i (click)="toggleFilters()" [nimbusIcon]="ICONS.CHEVRON_UP"></i>
    </div>
  }

  <div [class.compact-view]="compactView" class="filter-menu">
    <nimbus-nimbus-filter-menu
      [disabled]="disabled"
      [filterOptions]="filterOptions"
      [filterOptionsSelected]="filterOptionsSelected"
      (filterSelected)="onFilterSelected($event)"
    ></nimbus-nimbus-filter-menu>
  </div>
</div>
